export const ISLOGGEDIN_COOKIE = "isLoggedIn";

export const SUPPORT_WIDGET_HIDDEN_ROUTES = [
    "/financing",
    "/financing/",
    "/checkout/select-offer",
    "/checkout/select-offer/",
    "/price/communication",
    "/car-history-report",
    "/discover-car-finance",
    "/location-selector",
    "/sell-auto-valuation",
    "/car-history-auto",
    "/menu",
    "/login"
];
